exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-form p.title-section[data-v-59a55ee2]{margin-bottom:10px!important}", ""]);

// exports
